import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/mobile-navigation.css';
import App from './App';

// Enregistrer le Service Worker pour la PWA (activer aussi en développement pour tester)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/service-worker.js')
      .then((registration) => {
        console.log('✅ Service Worker enregistré avec succès:', registration.scope);
        
        // Vérifier les mises à jour du service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // Nouveau service worker disponible
                console.log('🔄 Nouveau Service Worker disponible');
                // Optionnel: Afficher une notification à l'utilisateur pour recharger
              }
            });
          }
        });
      })
      .catch((error) => {
        console.warn('❌ Erreur lors de l\'enregistrement du Service Worker:', error);
      });
  });
}

// Gestion des erreurs globales
window.addEventListener('error', (event) => {
  // Ignorer les erreurs des extensions de navigateur et les AbortError
  if (event.error && event.error.message && 
      (event.error.message.includes('message channel closed') ||
       event.error.message.includes('Extension context invalidated') ||
       event.error.message.includes('play() request was interrupted') ||
       event.error.message.includes('The play() request was interrupted'))) {
    return; // Ignorer silencieusement ces erreurs
  }
  // Ignorer aussi les AbortError par nom
  if (event.error && event.error.name === 'AbortError') {
    return; // Ignorer silencieusement
  }
  console.error('Erreur globale:', event.error);
});

window.addEventListener('unhandledrejection', (event) => {
  // Ignorer les erreurs des extensions de navigateur et des service workers
  const errorMessage = event.reason?.message || event.reason?.toString() || '';
  const errorName = event.reason?.name || '';
  const shouldIgnore = 
    errorMessage.includes('message channel closed') ||
    errorMessage.includes('Extension context invalidated') ||
    errorMessage.includes('listener indicated an asynchronous response') ||
    errorMessage.includes('asynchronous response') ||
    errorMessage.includes('message channel') ||
    errorMessage.includes('play() request was interrupted') ||
    errorMessage.includes('The play() request was interrupted') ||
    errorMessage.includes('Request scheme') ||
    errorMessage.includes('chrome-extension') ||
    errorMessage.includes('Failed to execute \'put\' on \'Cache\'') ||
    (errorName === 'ChromeExtensionError') ||
    (errorName === 'ExtensionContextInvalidatedError') ||
    (errorName === 'AbortError') ||
    (errorName === 'TypeError');
  
  if (shouldIgnore) {
    event.preventDefault(); // Empêcher l'affichage de l'erreur dans la console
    return;
  }
  
  // Ignorer aussi les erreurs sans message (souvent liées aux extensions)
  if (!event.reason || (!event.reason.message && !event.reason.toString)) {
    event.preventDefault();
    return;
  }
  
  console.error('Promesse rejetée:', event.reason);
  // Empêcher l'affichage par défaut pour éviter les erreurs dans la console
  event.preventDefault();
});

const root = ReactDOM.createRoot(document.getElementById('root'));

try {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} catch (error) {
  console.error('Erreur lors du rendu:', error);
  root.render(
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <h1>Erreur de chargement de l'application</h1>
      <p>{error.message}</p>
      <pre style={{ textAlign: 'left', background: '#f5f5f5', padding: '10px' }}>
        {error.stack}
      </pre>
    </div>
  );
}

